import api from '../core/api';

const findAll = async () => {
  const result = await api.get('/business');
  const business = result.data;
  return business;
};

export default {findAll};
